import { PlusOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ROUTES } from '../const/routes';

const StyledWrapper = styled.div`
	display: flex;
	justify-content: flex-end;

	a {
		color: #595959;
	}
`;

const InterpreterExtraFormLink = () => (
	<StyledWrapper>
		<Link to={ROUTES.APP.INTERPRETER}>
			<PlusOutlined />
			{' Přidat tlumočníka'}
		</Link>
	</StyledWrapper>
);

export default InterpreterExtraFormLink;
